'use client';

import { icons as lucideIcons } from 'lucide-react';

type Props = {
  iconName?: string | null;
  iconType?: 'lucide' | 'heroicons' | 'tabler' | null;
  className?: string;
};

const SAFE_LUCIDE = new Set([
  'Code',
  'Music',
  'School',
  'Presentation',
  'Hammer',
  'Users',
  'Cpu',
  'Rocket',
  'CalendarDays',
  'Sparkles',
  'LayoutGrid',
]);

export function DynamicIconRenderer({ iconName, iconType, className = 'h-6 w-6' }: Props) {
  if (iconType !== 'lucide' || !iconName || !SAFE_LUCIDE.has(iconName)) {
    const Fallback = lucideIcons.LayoutGrid;
    return <Fallback className={className} />;
  }

  const Icon = lucideIcons[iconName as keyof typeof lucideIcons] ?? lucideIcons.LayoutGrid;
  return <Icon className={className} />;
}

